import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { IContract } from '~/types/contract/models'
import { Contract } from '~/cynqueModules/dataObjects/Contract'

const apiEntityPath = '/api/contracts'

export async function getContracts({ apiPath = apiEntityPath } = {}) {
  const callingMn = getContracts.name
  return httpGet<IContract[]>({ callingMn, apiPath })
}

export async function getContract(id: string) {
  const callingMn = getContract.name
  const apiPath = `${apiEntityPath}/${id}`
  return httpGet<IContract>({ callingMn, apiPath })
}

export async function getContractsPreProcessed({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getContractsPreProcessed.name
  const rawContracts = await httpGet<IContract[]>({ callingMn, apiPath })
  return rawContracts.map((rawContact) => Contract(rawContact))
}

export async function getContractsForCompanyPreProcessed(companyId: TEntityId) {
  const apiPath = `/api/companies/${companyId}/contracts`
  const callingMn = getContractsForCompanyPreProcessed.name
  const contracts = await httpGet<IContract[]>({ callingMn, apiPath })

  const processedContracts = contracts.map((contract) => Contract(contract))
  console.debug(
    `getContractsForCompanyPreProcessed returning`,
    processedContracts
  )
  return processedContracts
}

export async function getContractsForCompanyAndSupplierPreProcessed(
  companyId: TEntityId,
  supplierId: TEntityId
) {
  const apiPath = `/api/companies/${companyId}/contracts`
  const callingMn = getContractsForCompanyAndSupplierPreProcessed.name
  const rawContracts = await httpGet<IContract[]>({ callingMn, apiPath })
  const filteredContracts =
    rawContracts.filter((contract) => contract.supplier?.id === supplierId) ??
    []
  const filteredProcessedContracts = filteredContracts.map((filteredContract) =>
    Contract(filteredContract)
  )
  console.debug(
    `getContractsForCompanyAndSupplierPreProcessed returning`,
    filteredProcessedContracts
  )
  return filteredProcessedContracts
}

export async function getContractsForCompanyAndSupplierAndOrderPreProcessed(
  companyId: TEntityId,
  supplierId: TEntityId,
  orderId: TEntityId
) {
  const apiPath = `/api/companies/${companyId}/contracts`
  const callingMn = getContractsForCompanyAndSupplierAndOrderPreProcessed.name
  const rawContracts = await httpGet<IContract[]>({ callingMn, apiPath })
  // console.debug(`${callingMn} rawContracts`, rawContracts)
  const filteredContracts =
    rawContracts.filter(
      (contract) =>
        contract.supplier?.id === supplierId && contract.order?.id === orderId
    ) ?? []
  // console.debug(`${callingMn} filteredContracts`, filteredContracts)
  const filteredProcessedContracts = filteredContracts.map((filteredContract) =>
    Contract(filteredContract)
  )
  // console.debug(
  //   `${callingMn} companyId: ${companyId} | supplierId: ${supplierId} | orderId: ${orderId}`
  // )
  console.debug(`${callingMn} returning`, filteredProcessedContracts)
  return filteredProcessedContracts
}

export async function getContractsForCompanyAndSupplierAndOpportunityPreProcessed(
  companyId: TEntityId,
  supplierId: TEntityId,
  opportunityId: TEntityId
) {
  const apiPath = `/api/companies/${companyId}/contracts`
  const callingMn =
    getContractsForCompanyAndSupplierAndOpportunityPreProcessed.name
  const rawContracts = await httpGet<IContract[]>({ callingMn, apiPath })
  // console.debug(`${callingMn} rawContracts`, rawContracts)
  const filteredContracts =
    rawContracts.filter(
      (contract) =>
        contract.supplier?.id === supplierId &&
        contract.opportunity?.id === opportunityId
    ) ?? []
  // console.debug(`${callingMn} filteredContracts`, filteredContracts)
  const filteredProcessedContracts = filteredContracts.map((filteredContract) =>
    Contract(filteredContract)
  )
  console.debug(
    `${callingMn} companyId: ${companyId} | supplierId: ${supplierId} | opportunityId: ${opportunityId}`
  )
  console.debug(`${callingMn} returning`, filteredProcessedContracts)
  return filteredProcessedContracts
}

export async function createContract(entity: IContract) {
  const callingMn = createContract.name
  const apiPath = apiEntityPath
  return httpPost<IContract>({ callingMn, apiPath, entity })
}

export async function updateContract(
  entityData: Partial<IContract>,
  id: TEntityId
) {
  const callingMn = updateContract.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialIContract = Partial<IContract>
  return httpPatchMerge<TPartialIContract>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteContract(entityData: IContract) {
  const callingMn = deleteContract.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
